<div class="modal modal--lg" data-cy="unknown-payment-modal">
  <div class="modal__cont modal__cont--lg thanks">
    <button type="button" class="modal__close modal__close--alt" data-cy="close-button" (click)="dialogRef.close(false)">
      <aiwyn-icon name="x"></aiwyn-icon>
    </button>

    <div class="ta--center">
      <div class="h2" data-cy="failed-modal-text">Unable to confirm whether payment was successful</div>
      <p class="mt-6 message">
        Before making another payment, please contact
        <span class="text-link">
          <a type="email" [href]="mailTo">
            support&#64;aiwyn.ai
          </a>
        </span>
        to confirm whether your payment was successful.
      </p>

    </div>

    <div class="mt-6 grid-row grid-row--jcc">
      <div class="grid-col grid-col--auto">
        <button
          andButton
          size="large"
          color="primary"
          data-cy="contacted-support-button"
          (click)="openEmail()"
        >
          Contact support
        </button>
      </div>
    </div>
  </div>
</div>
